import React from 'react';
import { ShinyText } from './animations/ShinyText';
const capabilities = ['Attack-path validation', 'AI-security validation', 'Fix verification', 'Evidence packs', 'MSSP-ready reporting', 'SaaS-style pricing', 'Continuous validation', 'Plain-English remediation', 'Self-serve onboarding', 'Shareable proof'];
export function ProofStrip() {
  const items = [...capabilities, ...capabilities];
  return <div className="relative w-full border-y border-white/5 bg-[#070a0e] py-6 overflow-hidden" data-id="element-772">
      <div className="fade-mask-x" data-id="element-773">
        <div className="flex gap-12 animate-marquee whitespace-nowrap" data-id="element-774">
          {items.map((cap, i) => <div key={i} className="flex items-center gap-3 flex-shrink-0" data-id="element-775">
              <span className="w-1 h-1 rounded-full bg-[#1a8fd4]" data-id="element-776" />
              <span className="font-mono text-sm uppercase tracking-widest" data-id="element-777">
                <ShinyText text={cap} speed={6} data-id="element-778" />
              </span>
            </div>)}
        </div>
      </div>
    </div>;
}